
const translations = {
  fr: {
    header: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      contact: "Contact",
    },

    home: {
      heroSubtitle:
        "Votre partenaire de confiance en Suisse pour l’assistance administrative et le secrétariat sur mesure.",
      heroSubtitle5:"Solutions de secrétariat et d'assistance administrative sur mesure — professionnelles, discrètes et locales en Suisse.",
        heroBtnServices: "SECRÉTARIAT • GESTION ADMINISTRATIVE • COMPTABILITÉ",
         heroBtnServices1:"Voir les services",
      heroBtnContact: "Contact",
      specialOfferBtn: "Profiter de l'offre",
      aboutTitle: "À propos",
      aboutText1:
        "HelvetAssist est votre partenaire de confiance en Suisse dédié à la gestion administrative et au secrétariat privé. Nous vous libérons de la charge mentale liée à vos formalités pour simplifier votre quotidien.",
      aboutText2:
        "Votre temps est précieux — nous nous occupons de toute votre gestion administrative.",
      aboutLink: "En savoir plus",
      servicesTitle: "Nos services",
servicesList: [
  {
    title: "Création d’entreprise",
    desc: "SA, Sàrl, RI – accompagnement complet en Suisse.",
  },
  {
    title: "Secrétariat administratif",
    desc: "Gestion quotidienne de vos tâches administratives.",
  },
  {
    title: "Facturation & débiteurs",
    desc: "QR-factures, paiements et rappels clients.",
  },
  {
    title: "Support RH",
    desc: "Gestion administrative du personnel et assurances sociales.",
  },
  {
    title: "Comptabilité",
    desc: "Préparation des factures et suivi des dépenses.",
  },
 
],
   testimonialsTitle: "Avis de nos clients",
      testimonials: [
        { text: "HelvetAssist me fait gagner des heures chaque semaine sur la gestion de mes factures et courriers.", author: "Indépendant, Vaud" },
        { text: "Un soutien administratif discret, fiable et d'une rigueur irréprochable au quotidien.", author: "Client privé, Vevey" },
        { text: "Service fantastique pour la prise en charge de ma pré-comptabilité. Réactifs et très professionnels ! ", author: "PME, Canton de Vaud" },
      ],
      specialOffers: [
        { img: "/images/services/facturation.jpeg", title: "Votre déclaration d'impôts à CHF 50.-", text: "Optimisez vos déductions et gagnez du temps. Nous traitons votre déclaration de manière rapide, précise et en toute confidentialité.⁠", tag: "Offre spéciale impôts⁠", href: "/contact" },
        { img: "/images/services/extarnlise.jpeg", title: "Secrétariat & Gestion administrative sur mesure⁠", text: "Libérez-vous des contraintes quotidiennes. Une prise en charge clé en main pour votre courrier, facturation et suivi administratif.⁠", tag: "OFFRE PROFESSIONNELS", href: "/contact" },
        { img: "/images/services/assurance.jpeg", title: "Optimisation des assurances & Demande de subsides", text: "Ne payez plus trop cher ! Nous analysons vos contrats d'assurance et prenons en charge vos demandes de subsides pour alléger vos primes.⁠", tag: "OFFRE PARTICULIERS⁠", href: "/contact" },
      ],
      ctaTitle: "Intéressé par nos services ?",
      ctaText: "Cliquez et remplissez le formulaire — nous vous contacterons rapidement.",
      ctaButton: "Nous contacter",
      welcome: "Bienvenue chez",
      offersTitle: "Offres spéciales",
    },

    about: {
      title: "À propos",
      quote: "Votre temps est précieux — nous nous occupons de toute votre gestion administrative.",
      subtitle: "SECRÉTARIAT • GESTION ADMINISTRATIVE • OPTIMISATION",
      intro1:
        "est votre partenaire de confiance en Suisse dédié à la gestion administrative et au secrétariat privé pour particuliers et entreprises. ",
      intro2:
        "Nous prenons en charge vos formalités quotidiennes : tri du courrier, gestion des factures, préparation des pièces fiscales, décomptes d'assurances et correspondance avec les administrations suisses.",
      missionTitle: "Mission",
      missionText: "Simplifier votre gestion administrative.",
      valuesTitle: "Valeurs",
      valuesText: "Discrétion & rigueur.",
      approachTitle: "Approche",
      approachText: "Sur-mesure & locale.",
      location:
        "📍 Actifs à Zurich, Genève et Lausanne · Sur demande dans toute la Suisse",
      whatWeDo: "Ce que nous faisons",
      services: [
  {
    title: "Création et structuration d’entreprise (SA, Sàrl, RI)",
    text:
      "Accompagnement administratif complet pour la création et la structuration de votre entreprise en Suisse, de l’idée jusqu’à l’immatriculation.",
  },
  {
    title: "Secrétariat externalisé & assistance administrative",
    text:
      "Gestion administrative quotidienne ou ponctuelle : traitement du courrier, organisation, suivi des dossiers et support sur mesure.",
  },
  {
    title: "Facturation & gestion du débiteur",
    text:
      "Émission de QR-factures, suivi des paiements et gestion des rappels pour assurer une trésorerie maîtrisée.",
  },
  {
    title: "Support RH externalisé & assurances sociales",
    text:
      "Gestion administrative du personnel, contrats, déclarations et coordination avec les assurances sociales selon les normes suisses.",
  },
  {
    title: "Comptabilité & gestion des fournisseurs",
    text:
      "Saisie des pièces comptables, préparation des paiements, suivi des fournisseurs et gestion des obligations TVA.",
  },
  {
    title: "Démarches officielles & correspondances",
    text:
      "Gestion des relations avec les administrations, rédaction de courriers et obtention d’attestations officielles.",
  },
],
      ctaTitle: "Vous ne trouvez pas votre bonheur ?",
      ctaText:
        "De la gestion courante aux démarches complexes, nous avons la solution adaptée à vos besoins.",
      ctaLink: "Explorer l'ensemble des services",
    },

    contact: {
      title: "Contact",
      subtitle:
        "Envoyez-nous votre demande et nous vous répondrons dans les plus brefs délais.",
      name: "Nom et prénom",
      email: "Email",
      message: "Message",
      messagePlaceholder: "Écrivez votre message ici...",
      serviceLabel: "Sélectionnez un service",
      servicePlaceholder: "— Choisir —",
      services: {
        realEstate: "Création et structuration d’entreprise (SA, Sàrl, RI)",
        companies: "Secrétariat externalisé & assistance administrative",
        health: "Facturation & gestion du débiteur",
        tourism: "Support RH externalisé & assurances sociales",
        expats: "Comptabilité & gestion des fournisseurs",
        family: "Démarches officielles & correspondances",
        pets: "Assistance administrative sur mesure, budget & secrétariat",
        events: "Déclaration d'impôts — dès CHF 50.-",
        other: "Installation en Suisse & permis de séjour",
        otherother: "Assurances, subsides & aides financières",
        last: "Autre", 
      },
      filesLabel:
        "Si vous avez des documents ou images supplémentaires, vous pouvez les joindre ici",
      optionsLabel:
        "Options supplémentaires (B2B / demandes spécifiques)",
      callback: "Je souhaite être contacté(e) par téléphone",
      phone: "Numéro de téléphone",
      company: "La demande concerne une entreprise",
      companyName: "Nom de l’entreprise",
      companyPhone: "Téléphone de l’entreprise",
      button: "Envoyer le message",
      direct: "Ou écrivez-nous directement :",
      success: "Message envoyé avec succès !",
      sending: "Envoi en cours..."
    },

    footer: {
      tagline: "Aide administrative, assistance & conciergerie",
      services: "Services",
      allServices: "Tous les services",
      contact: "Contact",
      rights: "Tous droits réservés.",
    },
  },

  en: {
    header: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact",
    },

    home: {
      heroSubtitle:
        "Your trusted partner in Switzerland for administrative support and tailored secretarial services.",
      heroSubtitle5:"Tailor-made secretarial and administrative support solutions — professional, discreet, and local in Switzerland.",
        heroBtnServices: "SECRETARIAL SERVICES • ADMINISTRATIVE MANAGEMENT • ACCOUNTING",
         heroBtnServices1:"View services",
      heroBtnContact: "Contact",
      specialOfferBtn: "Request service",
      aboutTitle: "About us",
      aboutText1:
        "HelvetAssist is your trusted partner in Switzerland, specializing in administrative management and private secretarial services. We relieve you of the mental load associated with administrative tasks, simplifying your daily life.",
      aboutText2: "Your time is valuable—we handle all your administrative management.",
      aboutLink: "Learn more",
      servicesTitle: "Our services",
    servicesList: [

  {
    title: "Business creation",
    desc: "SA, Sàrl, RI – full support in Switzerland.",
  },

  {
    title: "Administrative secretariat",
    desc: "Daily management of your administrative tasks.",
  },

  {
    title: "Invoicing & debt collection",
    desc: "QR invoices, payments, and client reminders.",
  },

  {
    title: "HR support",
    desc: "Administrative management of staff and social insurance.",
  },

  {
    title: "Accounting",
    desc: "Preparation of invoices and expense tracking.",
  },

],
      testimonialsTitle: "What our clients say",
      testimonials: [
        { text: "HelvetAssist saves me hours every week on managing my invoices and mail.", author: "Self-employed, Vaud" },
        { text: "Discreet, reliable, and impeccably rigorous day-to-day administrative support.", author: "Private client, Vevey" },
        { text: "Fantastic service for handling my pre-accounting. Responsive and very professional!.", author: "SME, Canton of Vaud" },
      ],
      specialOffers: [

  {
    img: "/images/services/facturation.jpeg",
    title: "Your tax return for CHF 50.-",
    text: "Optimize your deductions and save time. We handle your tax return quickly, accurately, and with full confidentiality.",
    tag: "Special tax offer",
    href: "/contact"
  },

  {
    img: "/images/services/extarnlise.jpeg",
    title: "Tailored secretarial & administrative management",
    text: "Free yourself from daily constraints. A complete, turnkey solution for your mail, invoicing, and administrative follow-up.",
    tag: "PROFESSIONAL OFFER",
    href: "/contact"
  },

  {
    img: "/images/services/assurance.jpeg",
    title: "Insurance optimization & subsidy applications",
    text: "Stop paying too much! We analyze your insurance contracts and handle your subsidy applications to reduce your premiums.",
    tag: "PRIVATE CLIENT OFFER",
    href: "/contact"
  },

],
      ctaTitle: "Interested in our services?",
      ctaText: "Click and fill out the form — we will get back to you shortly.",
      ctaButton: "Contact us",
      welcome: "Welcome to",
      offersTitle: "Special Offers"
    },

    about: {
      title: "About us",
      quote: "Your time is valuable—we handle all your administrative management.",
      subtitle: "SECRETARIAT • ADMINISTRATIVE MANAGEMENT • OPTIMIZATION",
      intro1:
        "is your trusted partner in Switzerland, dedicated to administrative management and private secretarial services for individuals and businesses.",
      intro2:
        "We handle your day-to-day administrative tasks: sorting mail, managing invoices, preparing tax documents, handling insurance statements, and corresponding with Swiss authorities.",
      missionTitle: "Mission",
      missionText: "Simplify your administrative management.",
      valuesTitle: "Values",
      valuesText: "Discretion & rigor",
      approachTitle: "Approach",
      approachText: "Bespoke & local.",
      location:
        "📍 Active in Zurich, Geneva and Lausanne · Available across Switzerland",
      whatWeDo: "What we do",
     services: [

{
title: "Business creation and structuring (SA, Ltd., Sole Proprietorship)",
text:
"Comprehensive administrative support for creating and structuring your business in Switzerland, from the initial idea to official registration.",
},

{
title: "Outsourced secretarial & administrative support",
text:
"Daily or occasional administrative management: handling mail, organization, file tracking, and tailored support.",
},

{
title: "Invoicing & accounts receivable management",
text:
"Issuing QR invoices, monitoring payments, and managing reminders to ensure healthy cash flow.",
},

{
title: "Outsourced HR support & social insurance",
text:
"Administrative HR management, contracts, declarations, and coordination with social insurance in accordance with Swiss regulations.",
},

{
title: "Accounting & supplier management",
text:
"Recording accounting entries, preparing payments, tracking suppliers, and managing VAT obligations.",
},

{
title: "Official procedures & correspondence",
text:
"Managing relations with authorities, drafting correspondence, and obtaining official certificates.",
},

],

      ctaTitle: "Can't find what you're looking for?",
      ctaText:
        "From day-to-day management to complex procedures, we have the solution tailored to your needs.",
      ctaLink: "Explore all services",
    },

    contact: {
      title: "Contact",
      subtitle:
        "Send us your request and we will get back to you as soon as possible.",
      name: "Full name",
      email: "Email",
      message: "Message",
      messagePlaceholder: "Enter your message...",
      serviceLabel: "Select a service",
      servicePlaceholder: "— Select —",
      services: {
        realEstate: "Business creation and structuring (SA, Sàrl, RI)",
        companies: "Outsourced secretarial services & administrative support",
        health: "Outsourced HR support",
        tourism: "Relocation & professional mobility",
        expats: "Business concierge & premium services",
        family: "Driver & professional mobility",
        pets: "Personal administrative assistance",
        events: "Settling in Switzerland – support for expatriates",
        other: "Everyday services & concierge",
        otherother: "Residential Real Estate & Concierge Services",
        last: "Other", 
      },
      filesLabel:
        "If you have additional documents or images, you can attach them here",
      optionsLabel: "Additional options (B2B / special requests)",
      callback: "I would like to be contacted",
      phone: "Phone number",
      company: "This request is for a company",
      companyName: "Company name",
      companyPhone: "Company phone number",
      button: "Send message",
      direct: "Or write to us directly:",
      success: "Message sent successfully!",
      sending: "Sending the form, please wait..."
    },

    footer: {
      tagline: "Administrative assistance & concierge services",
      services: "Services",
      allServices: "All services",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },

  de: {
    header: {
      home: "Startseite",
      about: "Über uns",
      services: "Dienstleistungen",
      contact: "Kontakt",
    },

    home: {
      heroSubtitle:
        "Ihr vertrauenswürdiger Partner in der Schweiz für administrative Unterstützung und maßgeschneiderten Sekretariatsservice.",
       heroSubtitle5:"Massgeschneiderte Sekretariats- und Verwaltungsunterstützung – professionell, diskret und lokal in der Schweiz.",
        heroBtnServices: "SEKRETARIAT • VERWALTUNG • BUCHHALTUNG",
        heroBtnServices1:"die Services ansehen",
      heroBtnContact: "Kontakt",
      specialOfferBtn: "Service anfragen",
      aboutTitle: "Über uns",
      aboutText1:
        "HelvetAssist ist Ihr vertrauenswürdiger Partner in der Schweiz für administrative Aufgaben und private Sekretariatsdienstleistungen. Wir nehmen Ihnen die mentale Last rund um Formalitäten ab und erleichtern so Ihren Alltag.",
      aboutText2: "Ihre Zeit ist kostbar – wir übernehmen Ihre gesamte administrative Verwaltung.",
      aboutLink: "Mehr erfahren",
      servicesTitle: "Unsere Dienstleistungen",
     servicesList: [

  {
    title: "Unternehmensgründung",
    desc: "AG, GmbH, Einzelunternehmen – umfassende Betreuung in der Schweiz.",
  },

  {
    title: "Administrative Assistenz",
    desc: "Tägliche Verwaltung Ihrer administrativen Aufgaben.",
  },

  {
    title: "Rechnungsstellung & Forderungsmanagement",
    desc: "QR-Rechnungen, Zahlungen und Kundenmahnungen.",
  },

  {
    title: "HR-Unterstützung",
    desc: "Administrative Personalverwaltung und Sozialversicherungen.",
  },

  {
    title: "Buchhaltung",
    desc: "Erstellung von Rechnungen und Kostenkontrolle.",
  },

],
      testimonialsTitle: "Kundenstimmen",
      testimonials: [
        { text: "HelvetAssist spart mir jede Woche Stunden bei der Verwaltung meiner Rechnungen und meiner Korrespondenz.", author: "Selbstständig, Vaud" },
        { text: "Diskrete, zuverlässige und absolut gewissenhafte administrative Unterstützung im Alltag.", author: "Privatkunde, Vevey" },
        { text: "Fantastischer Service für die Abwicklung meiner Vorbuchhaltung. Reaktionsschnell und sehr professionell!", author: "KMU, Kanton Vaud" },
      ],
      specialOffers: [

  {
    img: "/images/services/facturation.jpeg",
    title: "Ihre Steuererklärung für CHF 50.-",
    text: "Optimieren Sie Ihre Abzüge und sparen Sie Zeit. Wir bearbeiten Ihre Steuererklärung schnell, präzise und absolut vertraulich.",
    tag: "Sonderangebot Steuern",
    href: "/contact"
  },

  {
    img: "/images/services/extarnlise.jpeg",
    title: "Individuelles Sekretariat & administrative Betreuung",
    text: "Befreien Sie sich von täglichen Aufgaben. Eine schlüsselfertige Lösung für Ihre Korrespondenz, Rechnungsstellung und administrative Nachverfolgung.",
    tag: "ANGEBOT FÜR UNTERNEHMEN",
    href: "/contact"
  },

  {
    img: "/images/services/assurance.jpeg",
    title: "Versicherungsoptimierung & Subventionsanträge",
    text: "Zahlen Sie nicht mehr zu viel! Wir analysieren Ihre Versicherungsverträge und übernehmen Ihre Subventionsanträge, um Ihre Prämien zu senken.",
    tag: "ANGEBOT FÜR PRIVATKUNDEN",
    href: "/contact"
  },

],
      ctaTitle: "Interessiert an unseren Services?",
      ctaText: "Klicken Sie und füllen Sie das Formular aus — wir melden uns zeitnah.",
      ctaButton: "Kontakt aufnehmen",
      welcome: "Willkommen bei",
      offersTitle: "Sonderangebote",
    },

    about: {
      title: "Über uns",
      quote: "Ihre Zeit ist kostbar – wir übernehmen Ihre gesamte administrative Verwaltung.",
      subtitle: "SEKRETARIAT • ADMINISTRATIVE VERWALTUNG • OPTIMIERUNG",
      intro1:
        "ist Ihr vertrauenswürdiger Partner in der Schweiz für die administrative Verwaltung und das private Sekretariat – für Privatpersonen und Unternehmen.",
      intro2:
        "Wir übernehmen Ihre täglichen Formalitäten: Postsortierung, Rechnungsverwaltung, Vorbereitung von Steuerunterlagen, Versicherungsabrechnungen sowie die Korrespondenz mit Schweizer Behörden.",
      missionTitle: "Mission",
      missionText: "Vereinfachen Sie Ihre administrative Verwaltung.",
      valuesTitle: "Werte",
      valuesText: "Diskretion & Sorgfalt.",
      approachTitle: "Ansatz",
      approachText: "Maßgeschneidert & lokal",
      location:
        "📍 Aktiv in Zürich, Genf und Lausanne · Schweizweit verfügbar",
      whatWeDo: "Was wir tun",
     services: [

{
title: "Gründung und Strukturierung von Unternehmen (AG, GmbH, Einzelunternehmen)",
text:
"Umfassende administrative Begleitung bei der Gründung und Strukturierung Ihres Unternehmens in der Schweiz – von der Idee bis zur offiziellen Eintragung.",
},

{
title: "Externes Sekretariat & administrative Unterstützung",
text:
"Tägliche oder punktuelle administrative Verwaltung: Bearbeitung der Korrespondenz, Organisation, Dossierverfolgung und maßgeschneiderte Unterstützung.",
},

{
title: "Rechnungsstellung & Debitorenmanagement",
text:
"Erstellung von QR-Rechnungen, Überwachung der Zahlungseingänge und Mahnwesen zur Sicherstellung eines gesunden Cashflows.",
},

{
title: "Externe HR-Unterstützung & Sozialversicherungen",
text:
"Administrative Personalverwaltung, Verträge, Meldungen und Koordination mit Sozialversicherungen gemäß den schweizerischen Vorschriften.",
},

{
title: "Buchhaltung & Lieferantenmanagement",
text:
"Erfassung von Buchhaltungsbelegen, Vorbereitung von Zahlungen, Lieferantenverfolgung und Verwaltung der Mehrwertsteuerpflichten.",
},

{
title: "Behördliche Verfahren & Korrespondenz",
text:
"Abwicklung von Beziehungen mit Behörden, Verfassen von Schreiben und Einholung offizieller Bescheinigungen.",
},

],

      ctaTitle: "Haben Sie nicht das Richtige gefunden?",
      ctaText:
        "Von der laufenden Verwaltung bis hin zu komplexen Verfahren – wir haben die passende Lösung für Ihre Bedürfnisse.",
      ctaLink: "Alle Services entdecken",
    },

    contact: {
      title: "Kontakt",
      subtitle:
        "Senden Sie uns Ihre Anfrage und wir melden uns schnellstmöglich bei Ihnen.",
      name: "Vor- und Nachname",
      email: "E-Mail",
      message: "Nachricht",
      messagePlaceholder: "Geben Sie hier Ihre Nachricht ein...",
      serviceLabel: "Dienstleistung auswählen",
      servicePlaceholder: "— Auswahl —",
      services: {
        realEstate: "Unternehmensgründung und -strukturierung (SA, Sàrl, RI)",
        companies: "Ausgelagerte Sekretariatsdienste und administrative Unterstützung",
        health: "Ausgelagerte HR-Unterstützung",
        tourism: "Umzug und berufliche Mobilität",
        expats: "Business-Concierge-Service und Premium-Services",
        family: "Chauffeur-Service und berufliche Mobilität",
        pets: "Persönliche administrative Unterstützung",
        events: "Einleben in der Schweiz – Unterstützung für Expats",
        other: "SonstAlltagsdienstleistungen und Concierge-Serviceiges",
        otherother: "Immobilien- und Wohnconcierge-Service",
        last: "Sonstiges"
      },
      filesLabel:
        "Falls Sie zusätzliche Dokumente oder Bilder haben, können Sie diese hier anhängen",
      optionsLabel: "Zusätzliche Optionen (B2B / Sonderwünsche)",
      callback: "Ich möchte kontaktiert werden",
      phone: "Telefonnummer",
      company: "Anfrage betrifft ein Unternehmen",
      companyName: "Firmenname",
      companyPhone: "Firmentelefon",
      button: "Nachricht senden",
      direct: "Oder schreiben Sie uns direkt:",
      success: "Nachricht erfolgreich gesendet!",
      sending: "Wird gesendet..."
    },

    footer: {
      tagline: "Administrative Unterstützung & Concierge-Dienstleistungen",
      services: "Dienstleistungen",
      allServices: "Alle Dienstleistungen",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
  },
};

export default translations;
